import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getAttachments(axiosPrivate, decisionId) {
	return axiosPrivate
		.get(`${apiURL}/decision/${decisionId}/attachment.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				console.log("📎 Attachments API response:", res.data);
				// Debug: Log the file structure
				if (res.data && res.data.length > 0) {
					console.log("🔍 First attachment file structure:", res.data[0].file);
				}
				return res.data;
			}
			if (res.status === 404) {
				console.log("📎 No attachments found (404)");
				return []; // Return empty array instead of undefined
			}
		})
		.catch((err) => {
			console.error("❌ Attachments API error:", err);
			throw err; // Re-throw to allow proper error handling
		});
}

export async function getFile(axiosPrivate, link) {
	return axiosPrivate
		.get(link)
		.then((res) => res.blob())
		.then((blob) => {
			// Creating new object of PDF file
			const fileURL = window.URL.createObjectURL(blob);
			// Setting various property values
			let alink = document.createElement("a");
			alink.href = fileURL;
			alink.download = "SamplePDF.pdf";
			alink.click();
		})
		.catch((err) => err.response);
}

export async function addAttachment(axiosPrivate, decisionId, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/decision/${decisionId}/attachment.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Attachment added");
				cb();
			} else {
				toast.error("Could not add attachment. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			console.error("Attachment API Error:", err);
			throw err; // Re-throw to allow proper error handling in calling code
		});
}

export async function addAttachmentFromTempFile(axiosPrivate, decisionId, tempFileId, name, description) {
	const formData = new FormData();
	formData.append("name", name);
	formData.append("description", description);
	formData.append("tempFileId", tempFileId.toString());

	return axiosPrivate
		.post(`${apiURL}/decision/${decisionId}/attachment-from-temp.json`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				console.log("✅ Successfully created attachment from temp file");
				return res.data;
			} else {
				throw new Error("Failed to create attachment from temp file");
			}
		})
		.catch((err) => {
			console.error("❌ Attachment from temp file error:", err);
			throw err;
		});
}

export async function deleteAttachment(axiosPrivate, cb, attachmentId, decisionId) {
	return axiosPrivate
		.delete(`${apiURL}/decision/${decisionId}/attachment/${attachmentId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Attachment deleted");
				cb();
			} else {
				toast.error("Could not delete attachment. Please try again.");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
